export const styles = theme => ({
  content: {
    display: 'block',
    paddingTop: theme.spacing.unit * 2,
    paddingLeft: 0,
    paddingRight: 0
  },
  placeIcon: {
    marginRight: 0,
  },
  linearProgress: {
    marginLeft: theme.spacing.unit * 2,
    marginRight: theme.spacing.unit * 2
  },
  disabled: {
    opacity: 0.38
  },
  time: {
    display: 'flex',
    flex: 1,
    flexDirection: 'column',
    alignItems: 'center'
  }
})


// WEBPACK FOOTER //
// ./src/components/Blocking/styles.js